/**
* Scroll-triggered autoplay for deferred-media elements.
* Any <deferred-media data-scroll-autoplay> will start playing
* automatically when it scrolls into the viewport (≥30% visible),
* and pause when it leaves.
*/

/** @typedef {{ loadContent?: (focus: boolean) => void, playMedia?: () => void, pauseMedia?: () => void } & HTMLElement} DeferredMediaElement */

(function initScrollAutoplay() {
  const THRESHOLD = 0.3; // 30% of the element must be visible

  /** @param {DeferredMediaElement} el */
  function triggerPlay(el) {
    if (typeof el.loadContent === 'function') {
      el.loadContent(false); // false = don't steal focus
    }
    const videoEl = el.querSelector('video');
    if(videoEl) {
        videoEl.currentTime = 0;
        videoEl.play().catch(() => {})
    }
    if (typeof el.playMedia === 'function') {
      el.playMedia();
    }
  }

  /** @param {DeferredMediaElement} el */
  function triggerPause(el) {
    if (typeof el.pauseMedia === 'function') {
      el.pauseMedia();
    }

  }

  function observe() {
    const targets = /** @type {NodeListOf<DeferredMediaElement>} */ (
      document.querySelectorAll('deferred-media[data-scroll-autoplay]')
    );
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = /** @type {DeferredMediaElement} */ (entry.target);
          if (entry.isIntersecting) {
            triggerPlay(el);
          } else {
            triggerPause(el);
          }
        });
      },
      { threshold: THRESHOLD }
    );

    targets.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();